import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { Field, reduxForm, getFormSyncErrors } from 'redux-form';
import { InjectedRouter } from 'react-router';
import { IModalAction } from 'models/modal';
import { IDomainValue } from 'models/common';
import { IDomainValuesAction } from 'models/domainvalues/domainvalues';
import { IUserCard, IUserCardAction, IUserCardData } from 'models/user/usercard';
import CommentBox from 'components/FormControls/CommentBox';
import { IUserProfile, IUserProfileAction } from 'models/user/userprofile';
import { putUserProfile, userProfileSuccess } from 'redux/modules/user/userprofile';
import { userCardSuccess } from 'redux/modules/user/usercard';
import { IStore } from 'redux/IStore';
import { UnderlineButtonGrey } from 'components';
const { connect } = require('react-redux');

export interface IUserAbout {
	about: string;
}

interface IProps {
	userCardData: IUserCardData;
	userProfileData: IUserProfile;
	currentFormValues: IUserAbout;
	router: InjectedRouter;
	route: any;

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	formErrors?: any;
	countryDomainValues: IDomainValue[];
	getCountryDomainValues?: () => IDomainValuesAction;
	putUserProfile?: (user: IUserProfile) => void;
	userProfileSuccess?: (userProfile: IUserProfile) => IUserProfileAction;
	userCardSuccess?: (userCard: IUserCard) => IUserCardAction;

	/* functions props */
	t?: (key: string) => string;
	change?: (field: any, value: any) => void;
	onSubmit?: (form: IUserAbout) => void;
	showModal: (modalType: string, modalProps: any) => IModalAction;
	closeModal: () => IModalAction;
}

interface IState {
	editing: boolean;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserAboutForm extends React.Component<IProps, IState> {
	deleteImage: any;

	constructor(props) {
		super(props);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.state = {
			editing: false,
		};
	}

	public onSubmit(form: IUserAbout) {
		console.error('not implemented', form);
	}

	public handleClick() {
		this.setState({ editing: true });
	}

	public handleClose() {
		this.setState({ editing: false });
	}

	public handleSave() {
		const modifiedUserProfileData: IUserProfile = {
			...this.props.userProfileData,
			bio: this.props.currentFormValues.about,
		};
		const modifiedUserCardData: IUserCard = {
			...this.props.userCardData.usercard,
			about: this.props.currentFormValues.about,
		};
		/////////////////////////////
		// Update redux state
		/////////////////////////////
		this.props.userCardSuccess(modifiedUserCardData);
		/////////////////////////////
		// Send data to db and update userProfile state
		/////////////////////////////
		this.props.putUserProfile(modifiedUserProfileData);
		/////////////////////////////
	}

	public render() {
		const { handleSubmit, t, userCardData } = this.props;
		const { isMyProfile } = userCardData;
		const { editing } = this.state;
		const about = userCardData.usercard.about;
		return (
			<form onSubmit={handleSubmit(this.onSubmit)} className="about">
				<div className="about">
					{isMyProfile ? (
						<>
							{editing ? (
								<Field
									name="about"
									component={CommentBox}
									type="text"
									customTitle={t('User_UserCard_About')}
									// placeholder={t("User_UserCard_AboutText")}
									closeCommentBox={this.handleClose}
									handleSave={this.handleSave}
									maxLength={4000}
								/>
							) : (
								<>
									<p style={{ whiteSpace: 'pre' }} className={`${about ? '' : 'grayGigo'}`}>
										{about ? about : t('User_UserCard_AboutText')}
									</p>
									<UnderlineButtonGrey onClick={this.handleClick}>{t('BSPortal_Common_Edit')}</UnderlineButtonGrey>
								</>
							)}
						</>
					) : (
						<p className={`${about ? '' : 'grayGigo'}`}>{about ? about : t('User_UserCard_AboutText')}</p>
					)}
				</div>
			</form>
		);
	}
}

function mapStateToProps(state: IStore) {
	const userCardData = state.usercard;
	const userProfileData = state.userprofile.user;
	let currentFormValues: IUserAbout = null;
	if (state.form[c.FORM_NAME_ABOUT] && state.form[c.FORM_NAME_ABOUT].values) {
		currentFormValues = state.form[c.FORM_NAME_ABOUT].values;
	}
	let about = '';
	if (state.usercard && state.usercard.usercard.about) {
		about = state.usercard.usercard.about;
	}
	return {
		initialValues: {
			[c.FORM_NAME_ABOUT]: about,
		},
		userCardData,
		userProfileData,
		currentFormValues,
		formErrors: getFormSyncErrors(c.FORM_NAME_ABOUT)(state),
	};
}

let UserAbout = reduxForm(
	{
		form: c.FORM_NAME_ABOUT,
		enableReinitialize: true,
	},
	mapStateToProps,
)(UserAboutForm);

UserAbout = connect(mapStateToProps, (dispatch) => ({
	putUserProfile: (user: IUserProfile) => dispatch(putUserProfile(user)),
	userProfileSuccess: (userProfile: IUserProfile) => dispatch(userProfileSuccess(userProfile)),
	userCardSuccess: (userCard: IUserCard) => dispatch(userCardSuccess(userCard)),
}))(UserAbout);

export { UserAbout };
